import { FunctionComponent } from 'react';
import { NavLink } from 'react-router-dom';
import { useLocationDescriptor } from 'hooks';
import { LinkProps } from './types';

export const Link: FunctionComponent<LinkProps> = props => {
  const { routeId, routeParams, ...rest } = props;

  // Instantiate location descriptor generator
  const createTo = useLocationDescriptor(routeId);

  return <NavLink {...rest} to={createTo(routeParams)} />;
};
